import { z } from 'zod';
// Trips + countries contract (SPEC §3.4). Dates are ISO calendar dates
// (YYYY-MM-DD); the API stores them as Postgres `date` columns.
const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Expected YYYY-MM-DD');
// ---- Trip ----
export const tripCreateSchema = z
    .object({
    name: z.string().min(1, 'Name is required').max(120),
    start: isoDate,
    end: isoDate,
    tripType: z.string().max(60).optional(),
})
    .refine((d) => d.start <= d.end, {
    message: 'End must be on or after start',
    path: ['end'],
});
export const tripUpdateSchema = z
    .object({
    name: z.string().min(1).max(120).optional(),
    start: isoDate.optional(),
    end: isoDate.optional(),
    tripType: z.string().max(60).nullable().optional(),
})
    .refine((d) => d.start === undefined || d.end === undefined || d.start <= d.end, {
    message: 'End must be on or after start',
    path: ['end'],
});
export const tripSchema = z.object({
    id: z.string(),
    name: z.string(),
    start: isoDate,
    end: isoDate,
    tripType: z.string().nullable(),
    createdAt: z.string(),
});
// ---- Country ----
export const countryCreateSchema = z.object({
    name: z.string().min(1, 'Name is required').max(80),
    isoCode: z.string().length(2).optional(),
    order: z.number().int().optional(),
});
export const countryUpdateSchema = z.object({
    name: z.string().min(1).max(80).optional(),
    isoCode: z.string().length(2).nullable().optional(),
    order: z.number().int().optional(),
});
export const countrySchema = z.object({
    id: z.string(),
    tripId: z.string(),
    name: z.string(),
    isoCode: z.string().nullable(),
    order: z.number().int(),
});
// ---- Composite ----
export const tripWithCountriesSchema = tripSchema.extend({
    countries: z.array(countrySchema),
});
//# sourceMappingURL=trips.js.map